// src/components/jarvislyComponents/ValidationSuffix.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import React, { useMemo } from 'react';
import { CheckCircleOutlined, CloseCircleOutlined, LoadingOutlined } from '@ant-design/icons';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ValidationSuffix = ({ status, loading, extraSuffix = null }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const content = useMemo(() => {
    const isValidating = status === 'validating' || !!loading;
    const isSuccess = status === 'success';
    const isError = status === 'error';

    const wrapperStyle = {
      display: 'inline-flex',
      alignItems: 'center',
    };

    const boxStyle = {
      position: 'relative',
      width: 18,
      height: 18,
    };

    const iconCommon = {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      marginTop: 1,
    };

    return (
      <span style={wrapperStyle}>
        <span style={boxStyle}>
          <span style={{ ...iconCommon, visibility: isValidating ? 'visible' : 'hidden' }}>
            <LoadingOutlined />
          </span>
          <span style={{ ...iconCommon, visibility: isSuccess ? 'visible' : 'hidden' }}>
            <CheckCircleOutlined />
          </span>
          <span style={{ ...iconCommon, visibility: isError ? 'visible' : 'hidden' }}>
            <CloseCircleOutlined />
          </span>
        </span>
        {/* optional external suffix kept stable */}
        <span style={{ visibility: extraSuffix ? 'visible' : 'hidden' }}>
          {extraSuffix || null}
        </span>
      </span>
    );
  }, [status, loading, extraSuffix]);

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return content;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ValidationSuffix;

// *******************************************************************************
// HELPERS
// *******************************************************************************
